import { useEffect } from 'react';
import Events from '../utilities/EventEmitter';
import { useNavigate } from 'react-router-dom';

// This is used for handle specific issue related to 403 and server issue, should not be used in other places
export const PageNavigator = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const handleNavigate = (urlParams) => {
      // Handle simple string URL (legacy support)
      if (typeof urlParams === 'string') {
        navigate(urlParams);
        return;
      }

      // Handle object with URL and additional data
      if (urlParams?.url) {
        const { url, ...additionalData } = urlParams;
        navigate(url, {
          state: additionalData
        });
      }
    };
    Events.on('NavigateToAccessDenied', handleNavigate);
    return () => {
      Events.off('NavigateToAccessDenied', handleNavigate);
    };
  }, []);
  return null;
};
